import { JSONAPI_URLS } from '../../../consts/endpoints';
import fetchTableData from '../../../utils/fetchTableData';
import { isDefined } from '../../../utils/isDefined';
import mapCustomFilters from './mapCustomFilters';
import { mapPlatform } from './mapMitelData';

export default async function fetchRangesPaginate({
  query,
  client,
  getConnectRanges
}) {
  const queryParams = mapQueryParams({
    client,
    getConnectRanges
  });

  const requestUrl = JSONAPI_URLS.EXTERNAL_NO_RANGES;

  const response = await fetchTableData({
    query,
    queryParams,
    requestUrl,
    defaultSort: '',
    mapCustomFilters
  });
  const mappedRanges = mapPlatform(response?.data);

  return { ...response, data: mappedRanges };
}

export function mapQueryParams({ client }) {
  let queryParams = {
    include: ['client', 'provider', 'address'],
    fields: { client: ['name', 'csbc_routing'] },
    filter: { client_id: isDefined(client) ? { eq: client } : { gt: 0 } }
  };

  return queryParams;
}
